const radii = {
  '--corner-radius-2': '2px',
  '--corner-radius-4': '4px',
  '--corner-radius-8': '8px',
  '--corner-radius-32': '32px',
}

export default radii
